// extracted by mini-css-extract-plugin
export default {"container":"Cocina_container__EXBPN","background":"Cocina_background__rUMEM","b1":"Cocina_b1__q2QuO","b2":"Cocina_b2__TZKZj","b3":"Cocina_b3__VX61j","item1":"Cocina_item1__FrE7-"};